import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import { Alert } from "@mui/material";
import { PullToRefresh } from "@src/appV2/lib/PullToRefresh/PullToRefresh";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useRef } from "react";

import { PageContent } from "../components/PageContent";
import { useWorkerPendingShiftInvites } from "./api/useWorkerPendingShiftInvites";
import { ShiftInvitesEmptyState } from "./EmptyState";
import { ShiftInvitesList } from "./List";
import { ShiftInvitesLoadingPageState } from "./LoadingPageState";

export function ShiftInvitesPage() {
  const {
    data: shiftInvitesData,
    refetch: refetchShiftInvites,
    isLoading,
    isError,
    isSuccess,
  } = useWorkerPendingShiftInvites();

  const { stage } = useDefinedWorker();
  const isRestricted = stage === WorkerStage.RESTRICTED;

  const pendingShiftInvites = shiftInvitesData?.data ?? [];

  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <PageWrapper>
      <StickyScrollPageHeader
        title="Shift invites"
        isLoading={isLoading}
        scrollContainerRef={scrollRef}
      />

      <PageContent ref={scrollRef}>
        <PullToRefresh
          onRefresh={async () => {
            await refetchShiftInvites();
          }}
        />
        {isLoading && <ShiftInvitesLoadingPageState />}
        {isError && <Alert severity="error">Error loading shift invites.</Alert>}
        {isSuccess &&
          (pendingShiftInvites.length > 0 ? (
            <ShiftInvitesList shiftInvites={pendingShiftInvites} />
          ) : (
            <ShiftInvitesEmptyState hideBrowseShiftsButton={isRestricted} />
          ))}
      </PageContent>
    </PageWrapper>
  );
}
